export default function UserJar() {
    return {
        userExtended: null,
        user: null,
        userRoles: null,
    };
}
